import { Outlet } from 'react-router-dom';

// DataProvider is removed from here and will be added in App.js

const DataLayout = () => {
  return (
      <Outlet /> 
  );
};

export default DataLayout;